<template>
  <v-app>
    <template v-if="pageLoaded">
      <common-actions />
      <div v-if="$route.path == '/auth'" class="bg-img"></div>
      <template v-if="$route.name !== 'Getting Started' && $route.name !== 'Sign In'">
        <v-system-bar app dark>          
          <!-- <v-icon>mdi-message</v-icon> -->
          <span>DSRL SOFTWARE BUILD VERSION 0.100.16</span>
          <v-spacer></v-spacer>
          <v-icon color="primary">mdi-network-strength-2</v-icon>
          <v-icon color="primary">mdi-wifi-arrow-up-down</v-icon>
          <v-icon>mdi-bug-check</v-icon> ALL SYSTEMS NORMAL (Last Diagnosed 00:15 hours)
        </v-system-bar>
        <v-app-bar flat app color="secondary" dark>
          <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
          <!-- <div class="d-flex align-center"> -->
          <!-- <v-icon @click="$router.push('/')" left>mdi-heart-multiple</v-icon>             -->
          <v-toolbar-title class="font-weight-bold d-flex align-center">
            <v-img style="margin: 0;margin-right: 10px;" width="50px" contain src="./assets/logo_dark.png" />
            {{ $route.name }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- <v-btn small text v-if="webShareApiSupported" @click="shareViaWebShare" class="hidden-lg-and-up">
            <v-icon left>mdi-share</v-icon> INVITE
          </v-btn> -->
          <v-toolbar-items class="hidden-sm-and-down">
            <v-btn text v-if="!!currentUser" to="/orders">ORDERS</v-btn>
            <v-btn to="/" text>
              HOME
            </v-btn>
            <v-btn to="/tracking" text>
              TRACKING (Demo)
            </v-btn>            
            <v-btn to="/query-model" text>
              Lab Query!
            </v-btn>
            <!-- <v-btn to="/logs-viewer" text>
              Realtime Logs
            </v-btn> -->
            <!-- <v-btn to="/analyse-feed" text>
              Analyse Feed
            </v-btn>                         -->
            <!-- <v-btn text v-if="!!currentUser" to="/tasks">TASKS</v-btn> -->
            <v-btn to="/records" text>
              <!-- <v-badge content="3"> -->
                RECORDS
              <!-- </v-badge> -->
            </v-btn>            
          </v-toolbar-items>

          <!-- </div> -->
          <!-- 
      <v-spacer></v-spacer>

      <v-badge
        bordered                
        overlap
        color="secondary"
        content="1"        
        v-if="currentUser"
      >
        <v-btn
          to="/orders"
          small
          icon
          depressed
        >
          <v-icon>
            mdi-bell
          </v-icon>
        </v-btn>
      </v-badge> -->

          <!-- <v-btn            
        dark
        outlined
      >
      <v-icon left>mdi-headset</v-icon>
      HELP 
      </v-btn> -->
        </v-app-bar>

        <v-navigation-drawer temporary v-model="drawer" app>
          <div style="
              height: 100%;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
            ">
            <div>
              <v-row>
                <v-col class="text-center my-3">
                  <!-- <v-img  src="../assets/logo1.png" class="mx-auto mb-4" style="width:70%;"></v-img> -->

                  <v-card :ripple="false" flat color="transparent">
                    <v-img style="margin: 0 auto" width="120px" contain src="./assets/logo_dark.png" />
                  </v-card>
                  <!-- <span>
                    Veniu <span class="font-weight-medium">Connect</span> 
                  </span> -->
                </v-col>
              </v-row>
              <v-list class="nav-items">
                <v-list-item-group color="primary">
                  <v-list-item v-if="currentUser" to="/latest">
                    <v-list-item-title>SETTINGS</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="currentUser" to="/internships">
                    <v-list-item-title>LOGS</v-list-item-title>
                  </v-list-item>
                  <v-list-item :input-value="true" v-if="currentUser" to="/account">
                    <v-list-item-content>
                      <v-list-item-title>SHUTDOWN</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <!-- <v-list-item v-if="currentUser" to="/tasks">
                    <v-list-item-title>Tasks</v-list-item-title>
                  </v-list-item> -->
                  <!-- <v-list-item to="/service">
              <v-list-item-title>About</v-list-item-title>
          </v-list-item>
          <v-list-item to="/contact">
              <v-list-item-title>Contact</v-list-item-title>
          </v-list-item> -->
                </v-list-item-group>
              </v-list>
            </div>
          </div>
        </v-navigation-drawer>
      </template>

      <v-main>
        <router-view @refer="handleRefer($event)" :currentPerson="currentPerson"></router-view>
      </v-main>
      <v-bottom-navigation class="d-flex d-sm-none" app color="primary" grow
        v-if="!!currentUser && $route.name !== 'Getting Started'">
        <!-- <v-btn to="/tasks">
          <span>TASKS</span>
          <v-icon>mdi-forum</v-icon>
        </v-btn> -->
        <v-btn to="/latest">
          <span>LATEST</span>
          <v-icon>mdi-newspaper</v-icon>
        </v-btn>
        <v-btn to="/internships">
          <span>INTERNSHIPS</span>
          <v-icon>mdi-heart</v-icon>
        </v-btn>
        <v-btn to="/account">
          <span>PROFILE</span>

          <v-icon>mdi-account</v-icon>
        </v-btn>
      </v-bottom-navigation>
    </template>
    <v-progress-linear v-else :active="true" :indeterminate="true" absolute top color="primary"></v-progress-linear>
  </v-app>
</template>

<script>
import Home from "./views/Home";
import CommonActions from "./components/CommonActions.vue";
import { appSignOut } from "@/services/Auth";
import { mapGetters } from "vuex";
import { getInfluencer } from "./api/Persons";

export default {
  name: "App",

  components: {
    Home,
    CommonActions,
  },
  data: () => ({
    drawer: false,
    selectedItem: null,
    pageLoaded: false,
    currentPerson: {}
  }),
  computed: {
    webShareApiSupported() {
      return navigator.share;
    },
    ...mapGetters(["currentUser"]),
  },
  methods: {
    shareViaWebShare(code) {
      let url = "https://connect.veniu.in"

      if (typeof code == 'string') {
        url = url + '?referralCode=' + code
      }

      navigator.share({
        title: "Invitation to join Veniu Connect",
        text: "Start monetizing your digital presence with us",
        url: url
        // url: "https://veniu.connect.in/"+!!typeof code == 'string'? '?referralCode='+code : ''
      });
    },
    handleRefer(code) {
      // console.log(code)
      // console.log("https://veniu.connect.in/"+!!code? '?referralCode='+code : '')
      this.shareViaWebShare(code)
    },
    _signOut() {
      appSignOut()
        .then(() => {
          // this.$router.replace("/influencer-auth");
          window.location = "/auth";
        })
        .catch((e) => console.log(e));
    },
  },
  async created() {
    console.log("app created ...")

    if (!!this.currentUser & this.$route.path !== '/auth') {
      const influencer = await getInfluencer(this.currentUser.uid);
      this.currentPerson = influencer

      console.log('onboarded...', influencer.onboarded)

      if (!influencer.onboarded && this.$route.name !== "Getting Started") {
        this.$router.replace("/getting-started?step=1").catch(e => { })
      }

      if (influencer.onboarded && this.$route.name == "Getting Started") {
        this.$router.replace("/");
      }

    }
    this.pageLoaded = true;
  },
  mounted() {
    this.selectedItem = 0;
  },
  watch: {
    group() {
      this.drawer = false;
    },
  },
};
</script>


<style scoped>
a {
  text-decoration: none;
}

.bg-img {
  position: absolute;
  height: 100vh;
  z-index: -1;
  background: url("./assets/register_bg_mobile.png");
  background-size: contain;
  background-position: bottom;
  width: 100%;
  background-repeat: no-repeat;
}
</style>